export default defineNuxtRouteMiddleware(() => {
  if(import.meta.client) {
    const { removeAll } = useNotifications()
    removeAll()
  }
})
